<template>
  <!-- star -->
  <div class="service_wrap">
    <navigation></navigation>
    <div class="banner_warp">
      <img class="banner_warp_img" src="../assets/img/service/service_banner.png"/>
    </div>

    <!-- service -->
    <div class="service">
      <div class="service-top"></div>
      <h1>服务注册信息</h1>
      <div class="service-line"></div>
      <div class="service-content">
        <el-form :model="serviceForm" :rules="rules" label-position="top" ref="serviceForm" label-width="80px"
                 class="service-form">
          <div class="service-label"><h2>基本信息</h2>
            <div class="service-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="会员名" prop="memberName">
              <el-input v-model="serviceForm.memberName" placeholder="请输入您的会员名"></el-input>
            </el-form-item>
          </el-row>
          <el-row  class="service-el-row"> <!--:gutter="80"-->
            <el-col class="service-el-col" :span="12">  <!--:span="12"-->
              <el-form-item label="登录密码" prop="password" class="service-el-item">
                <el-input type="password" v-model="serviceForm.password" placeholder="请输入密码"
                          autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="service-el-col" :span="12"> <!--:span="12"-->
              <el-form-item label="密码确认" prop="checkPassword" class="service-el-item">
                <el-input type="password" v-model="serviceForm.checkPassword" placeholder="请再次输入密码"
                          autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="service-space"></div>
          <div class="service-label"><h2>企业信息</h2>
            <div class="service-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="企业名称" prop="companyName">
              <el-input v-model="serviceForm.companyName" placeholder="请输入企业名称"></el-input>
            </el-form-item>
          </el-row>
          <div class="service-space"></div>
          <div class="service-label"><h2>联系方式</h2>
            <div class="service-label-line"></div>
          </div>
          <el-row>
            <el-form-item label="联系人姓名" prop="contactName">
              <el-input v-model="serviceForm.contactName" placeholder="请输入联系人姓名"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="手机号码" prop="mobile">
              <el-input v-model="serviceForm.mobile" placeholder="请输入手机号码"></el-input>
            </el-form-item>
          </el-row>
          <el-row class="service-button-row">
            <el-form-item  class="service-el-form-item">
              <el-button class="service-el-button" type="primary" @click="submitForm('serviceForm')">提交</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </div>


    <footer2></footer2>
    <!-- end -->
  </div>
</template>

<script>
import navigation from "../components/nav2.vue";
import footer2 from "../components/footer.vue";
import {addService} from "@/api";

export default {
  name: "service",
  components: {
    navigation,
    footer2
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.serviceForm.checkPassword !== '') {
          this.$refs.serviceForm.validateField('checkPassword');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.serviceForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    let validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else {
        let newValue = value.replace(/[^0-9]/gi, '')
        if (value !== newValue) {
          callback(new Error('请输入正确的手机号码'))
        } else if (newValue.length !== 11) {
          callback(new Error('请输入正确的手机号码'))
        } else {
          callback()
        }
      }
    };
    return {
      serviceForm: {
        memberName: '',
        password: '',
        checkPassword: '',
        companyName: '',
        contactName: '',
        mobile: ''
      },
      rules: {
        memberName: [
          {required: true, message: '请输入会员名', trigger: 'blur'},
        ],
        password: [
          {required: true, validator: validatePass, trigger: 'blur'}
        ],
        checkPassword: [
          {required: true, validator: validatePass2, trigger: 'blur'}
        ],
        companyName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
        ],
        contactName: [
          {required: true, message: '请输入联系人姓名', trigger: 'blur'},
        ],
        mobile: [
          {required: true, validator: validateMobile, trigger: 'blur'},
        ]
      }
    };
  },
  mounted() {

  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          addService(this.serviceForm).then(response => {
            // console.log(12321);
            this.$message({
              message: '提交成功',
              type: 'success'
            });
          });
        } else {
          // console.log('error submit!!');
          this.$message.error('请输入必填项！');
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
/*=========================Reset_start==========================*/
/*去内外边距*/
html,
body {
  font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  text-align: left;
}

/*字体 文本居左*/
ul {
  list-style: none;
}

/*去ul li 小点*/
img {
  border: 0 none;
}

/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}

/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}

/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}

/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}

/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}

/*清浮动*/
a {
  color: #000000;
}

/*==========================Reset_End===========================*/
.service_wrap {
  width: 100vw;
  margin: 0 auto;
}

.banner_warp {
  width: 1920px;
  height: 366px;
}

.banner_warp_img {
  width: 1920px;
  z-index: -999;
  position: absolute;
  height: 366px;
}

.service {
  width: 100%;
  height: 1260px;
  background-size: contain;
}

.service h1 {
  color: #000000;
  font-size: 24px;
  line-height: 90px;
  text-align: center;
  font-weight: 600;
  font-family: PingFang SC, PingFang SC;
}

.service-top {
  width: 100%;
  padding-top: 60px;
}

.service-line {
  margin: auto;
  width: 252px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #B1B1B1;
}

.service-content {
  width: 740px;
  height: 900px;
  margin: 0 auto;
  margin-top: 50px;
}

.service-form {
  width: 740px;
  height: 900px;
}

.el-row {
  padding-top: 20px;
}

.el-form-item {
  width: 740px;
  height: 90px;
}

.service-el-row{
  margin-right: -40px;
  margin-left: -40px;
}

.service-el-col{
  /*float: left;*/
  padding-right: 40px;
  padding-left: 40px;
}

/deep/ .el-col-24{
  /*width: 410px;*/
}

.service-el-item {
  width: 330px;
  height: 90px;
}

/deep/ .el-form-item__label {
  line-height: 40px;
  font-size: 14px;
  color: #000000;
  font-weight: 600;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  margin-right: 4px;
  color: #E92424;
}

/deep/ .el-form-item__content {
  line-height: 40px;
  font-size: 14px;
}

/deep/ .el-input {
  font-size: 14px;
}

/deep/ .el-input__inner {
  line-height: 40px;
  border-radius: 4px;
  height: 40px;
  padding: 0 15px;
  border: 1px solid #DCDFE6;
}

.service-label h2 {
  color: #4B72B8;
  font-weight: 600;
  line-height: 19px;
  font-family: PingFang SC, PingFang SC;
  font-size: 16px;
}

.service-label-line {
  margin-top: 12px;
  width: 110px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #4B72B8;
}

.service-space {
  margin-top: 50px;
}

.service-button-row {
  width: 740px;
  height: 132px;
}

.service-el-form-item {
  margin-top: 50px;
  margin-left: 260px;
}

.service-el-button {
  background-color: #4B72B8;
  width: 237px;
  height: 42px;
  border-radius: 0px 0px 0px 0px;
  font-size: 14px;
  padding: 12px 20px;
  border: 1px solid #4B72B8;
}

/deep/ .el-form-item__error {
  font-size: 12px;
  padding-top: 4px;
}


</style>
